// Interface

import util from '@/utils/classToObject'
import { IUiState } from './state'
import { MeasureToolType } from '@/enum/MeasureToolType';
import { UiTab } from '@/models/ui/UiTab';
import { CoverageUiState } from '@/models/ui/CoverageUiState';
import { MissionPlanUiState } from '@/models/ui/MissionPlanUiState';
import { MissionUiState } from '@/models/ui/MissionUiState';


import Vue from 'vue';
import { GraphNmeaState } from '@/models/ui/GraphNmeaState';
import { GraphSimulationState } from '@/models/ui/GraphSimulationState';
import { AllGraphUiState } from '@/models/ui/AllGraphUiState';
import { CoverageIterationUiState } from '@/models/ui/CoverageIterationUiState';
import { CoverageIterationMissionUiState } from '@/models/ui/CoverageIterationMissionUiState';
import { SimulationUiState } from '@/models/ui/SimulationUiState';
import { SIMULATIONS_DETAIL_TABS } from '@/models/ui/SimulationTabs';
import { UiTabs } from '@/models/ui/UiTabs';
import { GraphUiState } from '@/models/ui/GraphUiState';
import { FleetUiState } from '@/models/ui/FleetUiState';

export class UiGetter {
  

  //// Dictionnaire des ui states
  
  public uistatebyuiid(state: IUiState) {
    return (uiid:string) => {
        //if(!state.uistates.hasOwnProperty(uiid)) Vue.set(state.uistates, uiid, new UiState())                
        return state.uistates[uiid]
    } 
  }

  public hideMap(state: IUiState) {
    return state.hideMap  
  }

  public coverageStateByUiid(state: IUiState) {
    return (uiid:string) => {        
        if(!state.uistates.hasOwnProperty(uiid)){
          const typeUiid = uiid.split('_')?.pop()
          Vue.set(state.uistates, uiid, new CoverageUiState({typeUiid}))                          
        } 
        return state.uistates[uiid] as CoverageUiState
    } 
  }

  public coverageIterationStateByUiid(state: IUiState) {
    return (uiid:string) => {        
        if(!state.uistates.hasOwnProperty(uiid)){
          const typeUiid = uiid.split('_')?.pop()
          Vue.set(state.uistates, uiid, new CoverageIterationUiState({typeUiid}))                          
        } 
        return state.uistates[uiid] as CoverageIterationUiState
    } 
  }

  public coverageIterationMissionUiStateByUiid(state: IUiState) {
    return (uiid:string) => {        
        if(!state.uistates.hasOwnProperty(uiid)){          
          Vue.set(state.uistates, uiid, new CoverageIterationMissionUiState())
        } 
        return state.uistates[uiid] as CoverageIterationMissionUiState
    } 
  }
  
  public missionPlanUiStateByUiid(state: IUiState) {
    return (uiid:string) => {        
        if(!state.uistates.hasOwnProperty(uiid)){
          const typeUiid = uiid.split('_')?.pop()
          Vue.set(state.uistates, uiid, new MissionPlanUiState({typeUiid}))                          
        } 
        return state.uistates[uiid] as MissionPlanUiState
    } 
  }

  public missionUiStateByUiid(state: IUiState) {
    return (uiid:string) => {        
        if(!state.uistates.hasOwnProperty(uiid)){
          const typeUiid = uiid.split('_')?.pop()
          Vue.set(state.uistates, uiid, new MissionUiState({typeUiid}))                          
        } 
        return state.uistates[uiid] as MissionUiState
    } 
  }

  public fleetUiStateByUiid(state: IUiState) {
    return (uiid:string) => { 
        if(!state.uistates.hasOwnProperty(uiid)){
          const typeUiid = uiid.split('_')?.pop()
          Vue.set(state.uistates, uiid, new FleetUiState({typeUiid}))                          
        } 
        return state.uistates[uiid] as FleetUiState
    }
  }

  public graphNmeaStateByUiid(state: IUiState) {
    return (uiid:string) => {        
        if(!state.uistates.hasOwnProperty(uiid)){          
          Vue.set(state.uistates, uiid, new GraphNmeaState())                          
        } 
        return state.uistates[uiid] as GraphNmeaState
    } 
  }

  public graphSimulationStateByUiid(state: IUiState) {
    return (uiid:string) => {        
        if(!state.uistates.hasOwnProperty(uiid)){          
          Vue.set(state.uistates, uiid, new GraphSimulationState())                          
        } 
        return state.uistates[uiid] as GraphSimulationState
    } 
  }

  public allGraphUiStateByUiid(state: IUiState) {
    return (uiid:string) => {        
        if(!state.uistates.hasOwnProperty(uiid)){          
          Vue.set(state.uistates, uiid, new AllGraphUiState())                          
        } 
        return state.uistates[uiid] as AllGraphUiState
    } 
  }

  public graphUiStateByUiid(state: IUiState) {
    return (uiid:string) => {        
        // if(!state.uistates.hasOwnProperty(uiid)){          
        //   Vue.set(state.uistates, uiid, new AllGraphUiState())                          
        // } 
        return state.uistates[uiid] as GraphUiState
    } 
  }

  public simulationUiStateByUiid(state: IUiState) {
    return (uiid:string) => {        
        if(!state.uistates.hasOwnProperty(uiid)){          
          const typeUiid = uiid.split('_')?.pop()
          if(typeUiid == "detail") {
            const leftCmp = SIMULATIONS_DETAIL_TABS.find(it => it.cmp == 'SimulationDetailMap')        
            const newLeft =  new UiTab(leftCmp)
            leftCmp!.id++
            Vue.set(state.uistates, uiid, new SimulationUiState({typeUiid,tabsleft:new UiTabs({
              tabs: [newLeft],
              selected: `${newLeft.cmp}-${newLeft.id}`
            })}))
          }
          else {
            Vue.set(state.uistates, uiid, new SimulationUiState({typeUiid}))              
          }
        } 
        return state.uistates[uiid] as SimulationUiState
    } 
  }

  /////// Fin Dictionnaire des ui states

  public uistates(state: IUiState) {
    return state.uistates
  }

  public darkmode(state: IUiState) {
    return state.darkmode
  }

  public smartPlanningUiState(state: IUiState) {
    return state.smartPlanningUiState
  }

  public isSmartMissionPlanModuleVisible(state:IUiState) {
    return (uiid:string) => {
      return ((state.uistates[uiid]?.tabsleft?.selected?.indexOf("SimulationDetailMissionPlan") ?? -1) == 0 ||
             (state.uistates[uiid]?.tabsright?.selected?.indexOf("SimulationDetailMissionPlan") ?? -1) == 0 ||
             (state.uistates[uiid]?.tabsleft?.selected?.indexOf("CoverageDetailMissionPlan") ?? -1) == 0 ||
             (state.uistates[uiid]?.tabsright?.selected?.indexOf("CoverageDetailMissionPlan") ?? -1) == 0||
             (state.uistates[uiid]?.tabsleft?.selected?.indexOf("FormationDetailParameter") ?? -1) == 0 ||
             (state.uistates[uiid]?.tabsright?.selected?.indexOf("FormationDetailParameter") ?? -1) == 0)           
    }    
  }  

  public isSmartMissionPlanModuleOpen(state:IUiState) {
    return (uiid:string) => {      
      return (state.uistates[uiid]?.tabsleft?.tabs ?? []).some((t:UiTab) => t.cmp == "SimulationDetailMissionPlan") ||
             (state.uistates[uiid]?.tabsright?.tabs ?? []).some((t:UiTab) => t.cmp == "SimulationDetailMissionPlan") ||
             (state.uistates[uiid]?.tabsleft?.tabs ?? []).some((t:UiTab) => t.cmp == "CoverageDetailMissionPlan") ||
             (state.uistates[uiid]?.tabsright?.tabs ?? []).some((t:UiTab) => t.cmp == "CoverageDetailMissionPlan")||
             (state.uistates[uiid]?.tabsleft?.tabs ?? []).some((t:UiTab) => t.cmp == "FormationDetailParameter") ||
             (state.uistates[uiid]?.tabsright?.tabs ?? []).some((t:UiTab) => t.cmp == "FormationDetailParameter")
    }    
  }  

  public isSmartParameterModuleVisible(state:IUiState) {
    return (uiid:string) => {      
      return ((state.uistates[uiid]?.tabsleft?.selected?.indexOf("SimulationDetailParameter") ?? -1) == 0 ||
             (state.uistates[uiid]?.tabsright?.selected?.indexOf("SimulationDetailParameter") ?? -1) == 0)      
    }    
  }  
  
  public isSmartCoverageParameterModuleVisible(state:IUiState) {
    return (uiid:string) => {      
      return ((state.uistates[uiid]?.tabsleft?.selected?.indexOf("CoverageDetailParameter") ?? -1) == 0 ||
             (state.uistates[uiid]?.tabsright?.selected?.indexOf("CoverageDetailParameter") ?? -1) == 0)      
    }    
  }  

  public isSmartFormationParameterModuleVisible(state:IUiState) {
    return (uiid:string) => {      
      return ((state.uistates[uiid]?.tabsleft?.selected?.indexOf("FormationDetailParameter") ?? -1) == 0 ||
             (state.uistates[uiid]?.tabsright?.selected?.indexOf("FormationDetailParameter") ?? -1) == 0)      
    }    
  }  
  

  public isDrawerOpen(state: IUiState) {
    return !!state.draweropen
  } 
  public soundNotification(state: IUiState) {
    return state.soundNotification
  }   
  public isRightDrawerOpen(state: IUiState) {
    return !!state.rightdraweropen
  }
  public missionMapVisibility(state: IUiState) {
    return state.missionMapVisibility
  }
  public simulationMapVisibility(state: IUiState) {
    return state.simulationMapVisibility
  }
  public simulationDetailVisibility(state: IUiState) {
    return state.simulationDetailVisibility
  }  
  public coverageMapVisibility(state: IUiState) {
    return state.coverageMapVisibility
  }
  public coverageDetailVisibility(state: IUiState) {
    return state.coverageDetailVisibility
  }
  public allMissionVisibility(state: IUiState) {
    return state.allMissionVisibility
  }
  public allFleetVisibility(state: IUiState) {
    return state.allFleetVisibility
  }
  public allSimulationVisibility(state: IUiState) {
    return state.allSimulationVisibility
  }  
  public missionDetailVisibility(state: IUiState) {
    return state.missionDetailVisibility
  }
  public fleetMapVisibility(state: IUiState) {
    return state.fleetMapVisibility
  }
  public fleetDetailVisibility(state: IUiState) {
    return state.fleetDetailVisibility
  }
  public currentMissionMapId(state: IUiState) {
    return state.currentMissionMapId
  }
  public coordFormatFilter(state: IUiState) {
    return state.coordFormatFilter
  }
  public measureTool(state: IUiState) {
    return state.measureTool
  }
  public refreshMesureTool(state: IUiState) {
    return state.refreshMesureTool
  }  
  public drawType(state: IUiState) {    
    switch(state.measureTool){
      case MeasureToolType.AREA: return 'polygon'
      case MeasureToolType.CIRCLE: return 'circle'
      case MeasureToolType.DISTANCE: 
      case MeasureToolType.BEARING: 
      case MeasureToolType.PROFILE_DEPTH: return 'line-string'      
      default: return null        
    }
  }
  public ongoingMissionActive(state: IUiState) {
    return !!state.ongoingMissionActive
  }
  public simulatedMissionActive(state: IUiState) {
    return !!state.simulatedMissionActive
  }
  public currentMovableDialog(state: IUiState) {
    return state.currentMovableDialog
  }
  public currentInfosDialog(state: IUiState) {
    return state.currentInfosDialog
  }
  public keyShiftPressed(state: IUiState) {
    return !!state.keys["ShiftLeft"] || !!state.keys["ShiftRight"]
  }  
  public keyControlPressed(state: IUiState) {
    return !!state.keys["ControlLeft"] || !!state.keys["ControlRight"]
  }
  public keySpacePressed(state: IUiState) {
    return !!state.keys["Space"]
  }
  public keyAltPressed(state: IUiState) {
    return !!state.keys["AltLeft"] || !!state.keys["AltRight"]
  }
  public keyLeftPressed(state: IUiState) {
    return !!state.keys["ArrowLeft"]
  }
  public keyUpPressed(state: IUiState) {
    return !!state.keys["ArrowUp"]
  }
  public keyRightPressed(state: IUiState) {
    return !!state.keys["ArrowRight"]
  }
  public keyDownPressed(state: IUiState) {
    return !!state.keys["ArrowDown"]
  }
  public redirectPath(state: IUiState) {
    return state.redirectPath
  }
  public snackMessages(state: IUiState) {
    return state.snackMessages
  }   
  public graphHover(state: IUiState) {
    return state.graphHover
  } 
}

export default util.classToObject(UiGetter)
